// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/card/style/index.less
// module id = 913
// module chunks = 1